import React from "react";
import { Phone, Mail } from "lucide-react";
import { company, heroStats } from "../mock";
import { CountUp, OrangeButton, Reveal } from "../components/common";

const Hero = () => {
  return (
    <section className="relative bg-[#0B102D] overflow-hidden">
      <div className="grid lg:grid-cols-4 min-h-screen">
        {/* Left content */}
        <div className="lg:col-span-1 flex flex-col justify-center px-5 lg:pl-12 lg:pr-8 pt-36 pb-16">
          <Reveal direction="left" delay={100}>
            <h1 className="display-heading text-white text-5xl sm:text-6xl lg:text-4xl xl:text-5xl mb-8">
              We build<br />everything<br />you need
            </h1>
          </Reveal>
          <Reveal direction="left" delay={250}>
            <p className="text-white/70 text-lg max-w-md mb-9 leading-relaxed">
              {company.intro} Trading since {company.since} on honesty, integrity,
              quality and trust.
            </p>
          </Reveal>
          <Reveal direction="up" delay={400}>
            <OrangeButton to="/services">View Services</OrangeButton>
          </Reveal>

          {/* Stats */}
          <div className="flex flex-wrap gap-10 mt-14">
            {heroStats.map((s, i) => (
              <Reveal key={i} direction="up" delay={550 + i * 150}>
                <div className="relative pl-6 max-w-[220px]">
                  <span className="absolute left-0 top-1 bottom-1 w-1 bg-[#CD0008]" />
                  <div className="display-heading text-white text-4xl md:text-5xl">
                    <CountUp end={s.value} suffix={s.suffix} />
                  </div>
                  <p className="text-white/60 text-sm mt-2 uppercase tracking-wide">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* Right video */}
        <div className="lg:col-span-3 relative min-h-[420px] lg:min-h-full overflow-hidden">
          <Reveal direction="right" className="absolute inset-0">
            <video
              src="https://customer-assets-wrfwihn1.emergentagent.net/job_family-builders-cam/artifacts/7uvuohff_0_Model_Two_story_1280x720%281%29.mp4"
              autoPlay
              loop
              muted
              playsInline
              poster="https://images.unsplash.com/photo-1587582423116-ec07293f0395?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
              className="w-full h-full object-cover"
            />
          </Reveal>
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B102D] via-transparent to-transparent lg:from-[#0B102D]/70" />

          {/* Floating contact cards */}
          <Reveal direction="up" delay={600} className="absolute bottom-6 left-6 right-6">
            <div className="flex flex-col sm:flex-row gap-4">
            <a href={company.phoneHref} className="flex items-center gap-3 bg-white/95 backdrop-blur rounded-md px-5 py-4 shadow-xl hover:bg-white transition-colors">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-[#CD0008] text-white shrink-0">
                <Phone size={18} />
              </span>
              <span>
                <span className="block text-xs text-gray-500 uppercase tracking-wide">Call Us</span>
                <span className="font-display font-bold text-[#0B102D]">{company.phone}</span>
              </span>
            </a>
            <a href={`mailto:${company.email}`} className="flex items-center gap-3 bg-white/95 backdrop-blur rounded-md px-5 py-4 shadow-xl hover:bg-white transition-colors">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-[#CD0008] text-white shrink-0">
                <Mail size={18} />
              </span>
              <span className="min-w-0">
                <span className="block text-xs text-gray-500 uppercase tracking-wide">Our Mail</span>
                <span className="font-display font-bold text-[#0B102D] text-sm break-all">{company.email}</span>
              </span>
            </a>
          </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;
